import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { FacilityReservation } from '../models/FacilityReservation';

export class ReservationService {
  static async getAllReservations(): Promise<FacilityReservation[]> {
    try {
      const q = query(
        collection(db, 'reservations'),
        orderBy('createdAt', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => {
        const data = doc.data();

        const reservation = {
          id: doc.id,
          facilityId: data.facilityId || '',
          facilityName: data.facilityName || '',
          userId: data.uid || '',
          userName: data.name || '',
          organization: data.organization || '',
          reservationDate: data.reservationDate?.toDate ? data.reservationDate.toDate() : new Date(),
          startTimeHour: data.startTime || 0,
          endTimeHour: data.endTime || 0,
          status: data.status || 'pending',
          createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date()
        } as FacilityReservation;

        return reservation;
      });
    } catch (error) {
      console.error('예약 목록 조회 실패:', error);
      return [];
    }
  }
} 